export default "__VITE_ASSET__BcwLNb$L__"